import React from 'react'

const createIcon = (props) => {
  switch (props.iconType) {
    case 'MI': return <i className="material-icons" >{props.icon}</i>
    case 'FA': return <i className={props.icon} ></i>
    default: return <i className={props.icon} ></i>
  }
}

const Action = (props) => {
  return (
    <div className='boton-circular' title={props.title} onClick={props.onClick}>
      {createIcon(props)}
    </div>
  )
}

export default Action